"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultStateProvider = void 0;
const react_1 = __importDefault(require("react"));
const StateProvider_1 = __importDefault(require("@usereactify/search-internals/lib/components/basic/StateProvider"));
const ResultStateProvider = (props) => (react_1.default.createElement(StateProvider_1.default, { componentIds: ["page"], includeKeys: ["isLoading", "hits", "resultStats", "error"], render: (state) => {
        const RenderComponent = props.render;
        return react_1.default.createElement(RenderComponent, Object.assign({}, state.searchState.page));
    } }));
exports.ResultStateProvider = ResultStateProvider;
//# sourceMappingURL=ResultStateProvider.js.map